const v37 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...state.options.tableViews.invoicesTable,
          'Invoice Number': true,
        },
      },
    },
  };
};

export default v37;
